
import { utclocalts } from '@/utils/utils'

export default {
  state: {
    counts: [],
    acumCounts: 0,
    acumDetentions: 0
  },

  mutations: {
    updateCounts(state, payloadCounts) {
      state.counts[payloadCounts.freq] = payloadCounts.counts
    },
    updateAcumCounts(state, acumCounts) {
      state.acumCounts = acumCounts
    },
  },

  actions: {
    async getCounts ({ commit }, payload) {
      try {
        const response = await this._vm.$http.get(`counts?devid=${payload.devid}&freq=${payload.freq}&start=${payload.start}&end=${payload.end}`)
        let counts = response.data.counts.map((val) => {
          return {
            x: utclocalts(val.date_s),
            y: val.count
          }
        })
        commit('updateCounts', {'freq': payload.freq, 'counts': counts})
      } catch (error) {
        console.log(error)
      }
    },
    async getAcumCounts ({ commit }, payload) {
      try {
        const response = await this._vm.$http.get(`counts?devid=${payload.devid}&freq=${payload.freq}&start=${payload.start}&end=${payload.end}`)
        let acumCounts = response.data.counts.reduce((acum, val) => {
          return acum + val.count
        }, 0)
        const kv = this.state.devices.currentDevice.kv  //test
        if(kv) {
          commit('updateAcumCounts', Math.floor(acumCounts/kv))
        } else {
          commit('updateAcumCounts', acumCounts)
        }
      } catch (error) {
        console.log(error)
      }
    },
  },

  getters: {
    counts(state) {
      return state.counts
    },
    acumCounts(state) {
      return state.acumCounts
    },
  }
}
